
// -- React Libraries
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import createClass from 'create-react-class';

// -- Libraries
import Helmet from 'react-helmet';
import LandingStyleWrapper from './style';
import axios from 'axios';
import appActions from '../../redux/itunesSearch/actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

// Components
import Header from "../../components/Headers/index";
import HeaderLogo from "../../components/Headers/Logo";
import HeaderMenu from "../../components/Headers/Menu";
import HeaderLogin from "../../components/Headers/LoginButton/index";
import Footer from "../../components/Footer/index";

import SearchApp from "../../components/SearchAppBar/index";

// Styles
import "../../Content/Styles/global.css";
import API_URL from './../../constants/server';

const Headline = createClass({
  render() {
      return <div className="headline">{this.props.children}</div>
  }
});
const Secondline = createClass({
  render() {
    return <div>{this.props.children}</div>
  }
});

class Landing extends Component {  
  constructor() {
    super()
    this.state = {
      redirectToReferrer: false,
      optionList : null,
      hasCampaigns: false
    };
  }

  login() {
    console.log( 'login')
    this.props.auth.login();
  }

  logout() {
    console.log( 'logout')
    this.props.auth.logout();
  }
  goTo(route) {
    this.props.history.push(`${route}`)
  }
  async componentDidMount(){
    console.log( 'didmount')
    if ( process.env.REACT_APP_STAGE !== 'fake' && this.props.auth.isAuthenticated() ){
      const { getAccessToken } = this.props.auth;
      const headers = { 'Authorization': `Bearer ${getAccessToken()}`}

      try {
        const response = await axios.get(`${API_URL}/user/campaigns`, { headers } )
        const campaignList = response.data;
        if (campaignList.length > 0){
          this.setState({
            hasCampaigns: true
          });
        }
      } catch (error) {
        console.log( '[getAccessToken] ', error); // error is not defined
      }

    }

    this.props.appSelected(null , null);    
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.isLoggedIn !== nextProps.isLoggedIn &&
      nextProps.isLoggedIn === true
    ) {
      this.setState({ redirectToReferrer: true });
    }
  }
  
  
  
  render() {
    const from = { pathname: '/dashboard' };
    const { redirectToReferrer } = this.state;
    const { isLoggedIn } = this.props;
    const { isAuthenticated } = this.props.auth;

    const title = "Project X";
    const description = "Best platform for Apple Search Ads";

    if ( process.env.REACT_APP_STAGE === 'fake' && isAuthenticated() ){
      return <Redirect to={{ pathname: '/campaign' }} />;
    } else if (isAuthenticated() && this.state.hasCampaigns){
      return <Redirect to={{ pathname: '/campaign' }} />;
    }
    if (redirectToReferrer) {
      return <Redirect to={{ pathname: '/dashboard' }} />;
    }

    return (
      <LandingStyleWrapper className="page-wrapper" style={{backgroundColor: "rgba(255, 255, 255, 1)"}}>
        <Helmet
          title={title}
          meta={[
            {'name': 'description', 'content': description},
            {'property': 'og:type', 'content': 'article'},
            {'property': 'og:title', 'content': title},
            {'property': 'og:description', 'content': description},
            // {'property': 'og:image', 'content': og && og['image']},
            // {'property': 'og:image:width', 'content': og && og['image:width']},
            // {'property': 'og:image:height', 'content': og && og['image:height']}
          ]}
          description="Best platform for Apple Search Ads">
            <meta charSet="utf-8" />
            <title> { title} </title>
            <link rel="canonical" href="https://project-x.gogochart.com/" />
            <meta name="description" content={ description } />
        </Helmet>
     
        <Header>
          <div className="header-row">
            <HeaderLogo isClickable={false} history={this.props.history} />

            {
              this.props.auth.isAuthenticated() && (
                <HeaderMenu history={this.props.history} auth={this.props.auth}/>
              ) || (
                <HeaderLogin history={this.props.history}>注册/登录</HeaderLogin>
              )
            }
          </div>
        </Header>

        <div>
          <div>
            <Headline>立马获得真实用户！</Headline>
            <Secondline>65%的下载直接来自APP商城</Secondline>
            <Secondline>现在开始获取优质用户！</Secondline>
          </div>

          <SearchApp
            placeholder="搜索你的应用名称或App ID"
            auth={this.props.auth}
            goTo={this.goTo.bind(this)}/>
        </div>

        <Footer/>
      </LandingStyleWrapper>
    );
  }
}

const  mapDispatchToProps = (dispatch) => {
  return { 
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoggedIn: state.getIn( ['Auth', 'idToken']) !== null ? true : false,
    countryCode: state.getIn( ['ItunesSearch', 'countryCode']) && 'US',
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Landing);



// WEBPACK FOOTER //
// ./src/containers/Landing/index.js